import classNames from 'classnames';

import profileImage from '../../assets/img/profile.svg';
import profileBackground from '../../assets/img/profile_background.svg';
import { useIsMobile } from '../../hooks';

import styles from './UserPhoto.module.scss';

type Props = {
  fullSize?: boolean,
  first_name?: string,
  last_name?: string,
  isHeader?: boolean,
  customText?: string,
};

const UserPhoto = (props: Props) => {
  const { fullSize, first_name, last_name, isHeader, customText } = props;
  const { isMobile } = useIsMobile();

  if (isHeader) {
    const text = customText || `${first_name && first_name[0]}${last_name && last_name[0]}`;
    return (
      <div className={classNames(styles.headerProfile, {
        [styles.fullWidth]: fullSize,
        [styles.backgroundMobile]: isMobile,
      })}
      >
        <span className={styles.text}>{text}</span>
      </div>
    );
  }

  return (
    <div className={styles.profileWrapper}>
      <img src={profileBackground} alt="profile background" className={fullSize ? styles.fullsizeBackground : styles.background} />
      <img src={profileImage} alt="profile" className={fullSize ? styles.fullsizeProfileImage : styles.profileImage} />
    </div>
  );
};

export default UserPhoto;
